import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {AlertService} from '../../services/alert.service';
import {Subscription} from 'rxjs';
import {NGXLogger} from 'ngx-logger';

@Component({
  selector: 'app-alerts',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.css']
})
export class AlertsComponent implements OnInit, OnDestroy {

  dismissible = true;
  alerts = [];

  // Deprecated

  @Input() errorMessage: string;
  showError = false;
  subscription: Subscription;

  errorMessages = [];

  constructor(
    private logger: NGXLogger,
    private alert: AlertService
  ) {
    this.subscription = alert.messageSource$.subscribe(
      // tslint:disable-next-line:no-shadowed-variable
      alert => {
        this.logger.log('Alert:', alert);
        this.alerts.push(alert);
      }
    );
  }

  ngOnInit() {
  }

  clear() {
    this.alerts = [];
  }

  removeMessage(i) {
    this.errorMessages.splice(i, 1);
    if (this.errorMessages.length === 0) {
      this.showError = false;
    }
  }

  closeErrors() {
    this.errorMessages = [];
    this.showError = false;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  reset(): void {
    this.alerts = [];
  }

  onClosed(dismissedAlert): void {
    this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
  }

}
